import AbstractModel, { Model } from './abstract-model';
import proj4 from "proj4";


@Model('BeanCoord')
export default class BeanCoord extends AbstractModel {
  public x: number = 0.0;
  public y: number = 0.0;
  public epsg: string = null;
  public userInfo: string = null;

  //transient
  public resolution: number = -1;

  static fromArray(coords: [number, number], epsg = "EPSG:4326"): BeanCoord {
    return new BeanCoord().inject({
      x: coords[0],
      y: coords[1],
      epsg
    });
  }

  project(epsg): BeanCoord {
    try {
      const coords = proj4(this.epsg.toLowerCase(), epsg.toLowerCase()).forward([this.x, this.y]);
      return new BeanCoord().inject({
        x: coords[0],
        y: coords[1],
        epsg,
        userInfo: this.userInfo,
        resolution: this.resolution
      });
    } catch (e) {
      return new BeanCoord().inject({
        epsg,
        userInfo: this.userInfo
      });
    }
  }

  asL93(): BeanCoord {
    return this.project("epsg:2154");
  }

  asWgs84(): BeanCoord {
    return this.project("epsg:4326");
  }

  asArray(): [number, number] {
    return [
      this.x,
      this.y
    ];
  }

  mutRound(decimals): this {
    const { pow } = Math;
    const rnd = d => Math.round((d+Number.EPSILON) * pow(10, decimals)) / pow(10, decimals);
    this.x = rnd(this.x);
    this.y = rnd(this.y);
    return this;
  }

  mergeKeepingProj(coords: BeanCoord) {
    const projected = coords.project(this.epsg);
    this.x = projected.x;
    this.y = projected.y;
  }

  getL93DistanceTo(to: BeanCoord): number {
    const { sqrt, pow } = Math;
    const thisL93 = this.asL93();
    const toL93 = to.asL93();
    return sqrt(pow(thisL93.x - toL93.x, 2) + pow(thisL93.y - toL93.y, 2));
  }

  get isInFrance(): boolean {
    const thisWgs84 = this.project("epsg:4326");
    return Number(thisWgs84.x) > -5.7 
      && Number(thisWgs84.x) < 12.5
      && Number(thisWgs84.y) > 38.8
      && Number(thisWgs84.y) < 53;
  }
}

